import {
  ADD_FEATURE_LAYER_TO_MAP,
  START_MEASURE,
  STOP_MEASURE,
  CLEAN_MEASURE,
} from './actionTypes';
import { removeFeatureLayerFromMap } from './layersFeature';
import {
  startMeasureService,
  stopMeasureService,
  cleanMeasureService,
} from '../../utils/measure';

export const startMeasure = (map, type) => (dispatch, getState) => {
  startMeasureService(map, type).then((vectorMeasure) => {
    dispatch({
      type: START_MEASURE,
    });
    
    // Sadece ölçüm katmanı state'de yoksa ekle
    const layersFeature = getState().layersFeature;
    const existingMeasureLayer = layersFeature.find(layer => 
      layer.get('title') === 'Ölçüm Katmanı'
    );
    
    if (!existingMeasureLayer) {
      dispatch({
        type: ADD_FEATURE_LAYER_TO_MAP,
        payload: vectorMeasure,
      });
    }
  });
};

export const stopMeasure = (map) => (dispatch) => {
  stopMeasureService(map);
  dispatch({
    type: STOP_MEASURE,
  });
};

export const cleanMeasure = (map) => (dispatch, getState) => {
  // Haritadan temizle
  cleanMeasureService(map);
  
  // Redux state'den de temizle
  const layersFeature = getState().layersFeature;
  const measureLayer = layersFeature.find(layer => 
    layer.get('title') === 'Ölçüm Katmanı'
  );
  
  if (measureLayer) {
    dispatch(removeFeatureLayerFromMap(measureLayer));
  }
  
  dispatch({
    type: CLEAN_MEASURE,
  });
};
